import { createAction, createReducer, createThunk } from '../../util/redux';

/*
 |--------------------------------------------------------------------------
 | Default state
 |--------------------------------------------------------------------------
 */

const defaultState = {
  toast: {
    isError: false,
    isOpen: false,
    message: null,
  },
  loading: false,
};

/*
 |--------------------------------------------------------------------------
 | Actions - anything that changes the store
 |--------------------------------------------------------------------------
 */

const HIDE_LOADER = 'HIDE_LOADER';
const hideLoader = createAction(HIDE_LOADER);
function hideLoaderHandler(state) {
  return { ...state, loading: false };
}

const SHOW_LOADER = 'SHOW_LOADER';
const showLoader = createAction(SHOW_LOADER);
function showLoaderHandler(state) {
  return { ...state, loading: true };
}

/*
 |--------------------------------------------------------------------------
 | Thunks - same as actions but returns a promise. Good for chaining
 |--------------------------------------------------------------------------
 */

const SHOW_TOAST = 'SHOW_TOAST';
const showToast = createThunk(SHOW_TOAST);
function showToastHandler(state, { payload }) {
  return {
    toast: {
      ...payload,
      isOpen: true,
    },
  };
}

const HIDE_TOAST = 'HIDE_TOAST';
const hideToast = createThunk(HIDE_TOAST);
function hideToastHandler(state) {
  return {
    toast: {
      ...state.toast,
      isOpen: false,
    },
  };
}

function sendErrorToastMessage(message) {
  return (dispatch) =>
    dispatch(showToast({ message, isError: true })).then(setTimeout(() => dispatch(hideToast()), 4000));
}

function sendToastMessage(message) {
  return (dispatch) =>
    dispatch(showToast({ message, isError: false })).then(setTimeout(() => dispatch(hideToast()), 4000));
}

/*
 |--------------------------------------------------------------------------
 | Reducer - maps the action to the action handler
 |--------------------------------------------------------------------------
 */

export const layoutReducer = createReducer(defaultState, {
  [SHOW_LOADER]: showLoaderHandler,
  [HIDE_LOADER]: hideLoaderHandler,
  [SHOW_TOAST]: showToastHandler,
  [HIDE_TOAST]: hideToastHandler,
});

/*
 |--------------------------------------------------------------------------
 | Action Exports
 |--------------------------------------------------------------------------
 */
export default {
  showLoader,
  hideLoader,
  sendErrorToastMessage,
  sendToastMessage,
};
